import { createContext } from 'react';

import type { NSearchIdProvider } from '@app/providers/SearchIdProvider/SearchIdProvider.types';

export const SearchIdContext = createContext<NSearchIdProvider.State>({
  searchId: null,
  setSearchId: () => {},
});
